import { useUser } from '@/hooks/useUser';
import { OrganizationRoles } from '@/enums';
import useOrganization from './useOrganization';

const useOrganizationRoles = () => {
  const { user, isLoading: isUserLoading } = useUser();
  const { organization, isLoading: isOrganizationLoading } = useOrganization();
  const members = organization?.members;

  // Find current user's membership info
  const currentUserMembership = members?.find((member) => member.user_id === user?._id);

  const userRole = currentUserMembership?.role;

  const isUserOwner = userRole === OrganizationRoles.OWNER;
  const isUserAdmin = userRole === OrganizationRoles.ADMIN;
  const isUserEditor = userRole === OrganizationRoles.EDITOR;
  const isLoading = isUserLoading || isOrganizationLoading;

  return {
    isUserOwner,
    isUserEditor,
    isUserAdmin,
    isLoading,
  };
};

export default useOrganizationRoles;
